import React from "react";
import "./App.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import {
  Landing,
  Terms,
  Privacy,
  Login,
  Signup,
  Dashboard,
  About,
  Services,
  Contact,
} from "./pages";
import TestDashboard from "./pages/TestDashboard/TestDashboard";
import CabDetails from "./pages/Booking/CabDetails";
import Bookings from "./pages/Bookings/Bookings";
import BookingDetails from "./pages/Bookings/BookingDetails";
import { AuthProvider } from "./contexts/AuthContext";
import { GoogleMapsProvider } from "./contexts/GoogleMapsContext";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

function App() {
  return (
    <GoogleMapsProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Switch>
            <Route path="/" exact component={Landing} />
            <Route path="/about" component={About} />
            <Route path="/services" component={Services} />
            <Route path="/contact" component={Contact} />
            <Route path="/privacy" component={Privacy} />
            <Route path="/terms" component={Terms} />
            {/* Auth pages - redirect to dashboard if already logged in */}
            <ProtectedRoute
              path="/signup"
              component={Signup}
              requireAuth={false}
            />
            <ProtectedRoute
              path="/login"
              component={Login}
              requireAuth={false}
            />
            {/* Dashboard - accessible to all users */}
            <Route path="/test-dashboard" component={TestDashboard} />
            {/* Cab Booking Dashboard */}
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/cab-details/:id" component={CabDetails} />
            {/* Booking Management */}
            <ProtectedRoute path="/bookings" exact component={Bookings} />
            <ProtectedRoute
              path="/bookings/:bookingId"
              component={BookingDetails}
            />
          </Switch>
        </BrowserRouter>
      </AuthProvider>
    </GoogleMapsProvider>
  );
}

export default App;
